import '..//..//..//mixins.js'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
// npm install jquery
export default {
  name: 'model-information',
  components: {spinner},
  props: {indicatorData: null},
  data () {
    return {
      indicators: null,
      isin:this.$route.params.ISIN,
      securityName: "",
      benchmarkIsin: "",
      benchmarkName: ""
    }
  },
  computed: {
  },
  beforeMount () {


  },
  mounted () {
       this.loadData();
  },
  methods: {

  loadData: async function() {
    this.benchmarkIsin = this.indicatorData["security_prices_benchmarks"]["isin"];
    this.benchmarkName = this.indicatorData["security_prices_benchmarks"]["name"];
    this.securityName = this.indicatorData["security_prices"]["name"];
    this.stockIndicators = this.indicatorData["indicators"][this.isin]
    this.benchmarkIndicators = this.indicatorData["indicators"][this.benchmarkIsin]

    this.displayIndicators("model_results");
  },

displayIndicators: function(key) {
  this.buttonActivation("nav-bar-indicators", "btn-indicator");
  this.updateSliders(this.stockIndicators[key], this.benchmarkIndicators[key], key);

},

updateSliders: function(selectedIndicatorsStock, selectedIndicatorsBenchmark, sliderKey) {
  var key;
  var keys = Object.keys(selectedIndicatorsStock);

  if(sliderKey == 'model_results'){
    document.getElementById("slider-fundamental").style.display = 'none';
    document.getElementById("span-text1-wrapper").style.display = 'none';
  }else{
    document.getElementById("slider-fundamental").style.display = 'block';
    document.getElementById("span-text1-wrapper").style.display = 'block';
  }

    // set span text
    for(var z = 0; z < keys.length; z++) {
      key = keys[z];
      document.getElementById("span-text" + z.toString()).innerHTML = key;
      
      document.getElementById("tooltip" + z.toString()).innerHTML = "Stock: " + (selectedIndicatorsStock[key]["value"] *100).toFixed(2) + "% --- Benchmark: " + (selectedIndicatorsBenchmark[key]["value"] *100).toFixed(2) + "%" ;
      document.getElementById("slider-stock-" + z.toString()).value = (selectedIndicatorsStock[key]["bin"]).toFixed(2) ;
      document.getElementById("tooltipIndicator" + z.toString()).innerHTML = selectedIndicatorsStock[key]["description"];

      document.getElementById("slider-benchmark-" + z.toString()).value = (selectedIndicatorsBenchmark[key]["bin"]).toFixed(2) ;
    }


}


  }
}







